package com.eladfinish.bible.contest.features.verseWidget

import com.eladfinish.bible.contest.di.config.DebugInfo
import com.russhwolf.settings.Settings
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val verseWidgetModule = module {
    // Android and iOS bind their own over this one
    single<VerseWidgetHost> { UnsupportedVerseWidgetHost }
    single { VerseWidgetConfigRepository(settings = get()) }
    factoryOf(::GetParashaRangeUseCase)
    // Not factoryOf: it would look for the PlatformTarget in Koin instead of using the parameter's default
    factory { GetVerseWidgetExampleImageUrlUseCase(getRemoteConfigValueUseCase = get()) }
    factoryOf(::UpdateVerseWidgetUserPropertyUseCase)
    factory {
        VerseWidgetEventsReporter(
            settings = get(),
            configRepository = get(),
            analyticsProvider = get(),
            updateUserProperty = get(),
        )
    }
    single { VerseWidgetPromptSession() }
    factory {
        val settings = get<Settings>()
        val isDebugMode = get<DebugInfo>().isDebugMode
        VerseWidgetPromptGate(
            settings = settings,
            remoteConfigRepository = get(),
            host = get(),
            session = get(),
            isSupportedPlatform = isVerseWidgetPlatform,
            isForced = { isDebugMode && settings.getBoolean(VerseWidgetPromptGate.KEY_DEBUG_FORCE, false) },
        )
    }
    factoryOf(::VerseWidgetPromptReporter)
    factoryOf(::GetWidgetVerseUseCase)
    factoryOf(::BuildWidgetScheduleUseCase)
}
